import { render, staticRenderFns } from "./option-sort-modal.vue?vue&type=template&id=5c292720&scoped=true&"
import script from "./option-sort-modal.vue?vue&type=script&lang=js&"
export * from "./option-sort-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c292720",
  null
  
)

export default component.exports